// Curated, verified Unsplash photography (people / offices / collaboration) used across the public site.
const u = (id, w = 1400) => `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;

export const IMG = {
  heroWide: u("1522071820081-009f0129c71c", 1800),      // team around laptop
  teamTable: u("1521737711867-e3b97375f902", 1600),     // team at table
  colleaguesLaptop: u("1556761175-b413da4baf72"),      // colleagues at laptop
  womanLaptop: u("1573497019940-1c28c88b4f3e"),        // woman working
  discussion: u("1531482615713-2afd69097998"),         // team discussion
  collaboration: u("1552664730-d307ca884978"),         // collaboration sticky notes
  meeting: u("1542744173-8e7e53415bb0"),               // meeting
  handshake: u("1600880292203-757bb62b4baf"),          // handshake
  laptops: u("1519389950473-47ba0277781c"),            // laptops on table
  planning: u("1553877522-43269d4ea984"),              // planning board
  developers: u("1551434678-e076c223a692"),            // developers at work
  developer: u("1504384308090-c894fdcc538d"),          // developer
  code: u("1498050108023-c5249f4df085"),               // code laptop
  manPortrait: u("1560250097-0b93528c311a", 900),      // businessman
  womanPortrait: u("1573496359142-b8d87734a5a2", 900), // businesswoman
  man2: u("1507003211169-0a1dd7228f2d", 400),
  woman2: u("1494790108377-be9c29b29330", 400),
  woman3: u("1438761681033-6461ffad8d80", 400),
  man3: u("1472099645785-5658abf4ff4e", 400),
  handshake2: u("1521791136064-7986c2920216"),
  highfive: u("1551836022-d5d88e9218df"),
  presentation: u("1524178232363-1fb2b075b655"),
  manLaptop: u("1556157382-97eda2d62296"),
  boardroom: u("1541746972996-4e0b0f43e02a"),
  teamOffice: u("1568992687947-868a62a9f521"),
  officeDesk: u("1497366216548-37526070297c"),
  officeOpen: u("1497366811353-6870744d04b2"),
  cityOffice: u("1486406146926-c627a92ad1ab"),
  strategy: u("1523240795612-9a054b0db644"),
  workshop: u("1517245386807-bb43f82c33c4"),
  agency: u("1529156069898-49953e39b3ac"),
  engineer: u("1581091226825-a6a2a5aee158"),
  standup: u("1593642532744-d377ab507dc8"),
  glasses: u("1531973576160-7125cd663d86"),
  hallway: u("1520607162513-77705c0f0d4a"),
  skyline: u("1559136555-9303baea8ebd"),
  dashboard: u("1454165804606-c3d57bc86b40"),
  callcenter: u("1543269865-cbf427effbad"),
  analytics: u("1573164713988-8665fc963095"),
  officePlant: u("1590650153855-d9e808231d41"),
  boardroom2: u("1565688534245-05d6b5be184a"),
};

export const AVATARS = [IMG.man2, IMG.woman2, IMG.man3, IMG.woman3];
